const MAX_DIGITS = 13;

export function sanitizePhoneDigits(value) {
  return value.replace(/\D/g, "").slice(0, MAX_DIGITS);
}

export function formatJapanesePhoneNumber(digits) {
  if (!digits) return "";

  const length = digits.length;

  if (digits.startsWith("0120") || digits.startsWith("0800") || digits.startsWith("0570")) {
    if (length <= 4) return digits;
    if (length <= 7) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
    if (length <= 10) {
      return `${digits.slice(0, 4)}-${digits.slice(4, 7)}-${digits.slice(7, 10)}`;
    }

    return `${digits.slice(0, 4)}-${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
  }

  if (digits.startsWith("03") || digits.startsWith("06")) {
    if (length <= 2) return digits;
    if (length <= 6) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
  }

  if (length >= 11) {
    if (length <= 11) {
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
    }

    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}-${digits.slice(11)}`;
  }

  if (length <= 3) return digits;
  if (length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}
